import {Component, inject, OnDestroy, OnInit} from '@angular/core'
import {Subscription} from 'rxjs'
import {AppNotification} from '@core/models/app-notification.model'
import {NotificationService} from '@core/services/notification.service'


@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: true,
    imports: [],
})
export class NotificationComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService)

  protected notification: AppNotification | null = null

  private notificationSubscription!: Subscription

  ngOnInit(): void {
    this.notificationSubscription = this.notificationService.notification$.subscribe(notification => {
      this.notification = notification

      setTimeout(() => this.notification = null, 5000)
    })
  }

  ngOnDestroy(): void {
    this.notificationSubscription.unsubscribe()
  }
}
